module.exports = __webpack_public_path__ + "img/1_newYouth_ch.095032dd.png";